import { Link } from 'react-router-dom';
import React from 'react';
import { Card } from 'react-bootstrap';
import { ChevronRight } from 'lucide-react';

const CardsAssistant = ({
  CardLabel,
  phone,
  email,
  PageRoute,
  CardColor = 'bg-brand-light'
}) => {
  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <Card className={`border-0 rounded-12 ${CardColor} card-managers`}>
      <Card.Body className="p-16">
        <div className="d-flex align-items-center mb-16 header">
          <div className="avatar-pill me-7"><span className="text-12 fw-700 text-navy">{getInitials(CardLabel)}</span></div>
          <h6 className="text-16 fw-700 text-navy mb-0">{CardLabel}</h6>
        </div>

        <div className="mb-24">
          {phone && (
            <a href={`tel:${phone}`}>
              <div className="d-flex align-items-center contact-item mb-10">
                <img src="/assets/icons/phone.svg" alt="Phone" className="me-6" width="14" height="13" />
                <span className="text-14 fw-500 text-navy">{phone}</span>
              </div>
            </a>
          )}

          {email && (
            <a href={`mailto:${email}`}>
              <div className="d-flex align-items-center contact-item">
                <img src="/assets/icons/email.svg" alt="Email" className="me-6" width="14" height="14" />
                <span className="text-14 fw-500 text-navy">{email}</span>
              </div>
            </a>
          )}
        </div>

        <Link to={PageRoute} className="text-decoration-none">
          <div className="view-details-btn d-inline-flex align-items-center border border-brand">
            <span className="text-16 fw-700 text-brand">View Details</span>
            <ChevronRight size={16} className="text-brand ms-1" />
          </div>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default CardsAssistant;
